import { defineMessages } from 'react-intl'

export const passwordFieldMessages = defineMessages({
  placeholder: {
    id: 'passwordField.placeholder',
    description: 'Default placeholder for Password input',
    defaultMessage: 'Password',
  },
})
